import styled from "styled-components"
import { theme } from "../../styles/themes/default"
import { ThumborLoader } from '../../util/thumborLoader'

/**
 * A Imagem do Theo do PopUp do WhatsApp não deve ser alterada para ser lida via tema como as demais
 */
const ImageTheo = `${process.env.INTERNAL_IMAGES_URL}/images/png/theo.png`
const ImageTheoThumbor = ThumborLoader({ src: ImageTheo, width: 190 })

export const PopupContainer = styled.div`
  display: ${props => props.visible ? 'flex' : 'none'};
  flex-direction: column;
  pointer-events: all;
`

export const CloseButton = styled.button`
  align-self: flex-end;
  margin-bottom: 20px;

`

export const PopupBox = styled.a`
  position: relative;
  height: 90px;
  width: 140px;
  background: white url('${ImageTheoThumbor}') -55px 0/cover no-repeat;
  border-radius: 10px;
  box-shadow: 0 0 5px 1px #bbb;
  display: flex;
  justify-content: flex-end;
`

export const WhatsAppIcon = styled.div`
  position: absolute;
  background-color: transparent;
  border-radius: 50%;
  top: -20px;
  left: 50%;
`

export const TextBox = styled.div`
  max-width: 70px;
  padding-top: 25px;
`

export const TextTitle = styled.p`
  font-size: 12px;
  font-weight: bold;
  line-height: 13px;
  margin-bottom: 5px;
  color: ${theme.colors.grey[100]};
`

export const TextSubtitle = styled.p`
  font-size: 12px;
  line-height: 13px;
  margin-bottom: 0;
  color: ${theme.colors.grey[100]};
`
